module.exports = __webpack_public_path__ + "static/media/sara_us.d60cce43.png";